import React, { useState, useEffect, useRef } from "react";
import "./FAQ.css";
import image from "../../assets/images/thumbnail.svg";
import arrowIcon from "../../assets/images/arrowOut.svg";
import arrowBack from "../../assets/images/arrowBack.svg";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Header from "../../components/Header/Header";
import faqPDF from "../../assets/logos/UPL Genie FAQ Final 2.pdf";
import userPDF from "../../assets/logos/UPL Genie User Guide - Final 2.pdf";

const videos = [
  {
    title: "UPL Genie Introduction",
    time: "02:23",
    thumbnail: image,
    url: "https://upllimited.sharepoint.com/:v:/s/CDTCommunicationPortal/EUrf55B5pqlDos-kPfTR_wMBbh4kgE9wHHxNickCelMPDQ?e=WfuUl4",
  },
  {
    title: "UPL Genie Chat Guide",
    time: "01:59",
    thumbnail: image,
    url: "https://upllimited.sharepoint.com/:v:/s/CDTCommunicationPortal/EfyuwDdNuOxKl620eKQAnRcB4yMp33ToTEK2P1r1Gn8gqA?e=flLSGj",
  },
  {
    title: "UPL Genie Custom Assistant",
    url: "https://upllimited.sharepoint.com/sites/CDTCommunicationPortal/_layouts/15/stream.aspx?id=%2Fsites%2FCDTCommunicationPortal%2FShared%20Documents%2FVideos%2FUPLGenie%2FUPL%20Genie%20Custom%20Assistant%2Emp4&ga=1&referrer=StreamWebApp%2EWeb&referrerScenario=AddressBarCopied%2Eview%2E2f038435%2Deccc%2D426e%2Db493%2Df52dd9de583e",
    time: "02:51",
    thumbnail: image,
  },
];
const getFullname = () => {
  const storedData = localStorage.getItem("LoggedInDetails");
  if (storedData) {
    const parsedData = JSON.parse(storedData);
    return parsedData.full_name;
  }
  return null;
};
const FAQ = () => {
  const [selectedModel, setSelectedModel] = useState("GPT-4o");
  const fullname = getFullname();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [playingIndex, setPlayingIndex] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const handleBack = () => {
    navigate("/chat");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".user-dropdown") &&
        !event.target.closest(".icon-button")
      ) {
        setIsUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleModelChange = (eventOrName) => {
    let modelName;

    if (typeof eventOrName === "string") {
      modelName = eventOrName;
    } else if (eventOrName?.target?.value) {
      modelName = eventOrName.target.value;
    }

    if (modelName) {
      setSelectedModel(modelName);
      setIsOpen(false);
    }
  };
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleFaqNavigation = () => {
    navigate("/user-guide");
  };

  const handleOpenForm = () => {
    window.open(
      "https://forms.office.com/r/i2Wzj1baFs",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <>
      <ToastContainer
        closeButton={true}
        autoClose={1000}
        position="top-right"
      />
      <div className="chat-container">
        <div
          style={{
            height: "100%",
            backgroundColor: "#F9F9F9",
            overflowY: "hiden",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            gridTemplateRows: "9% 91%",
          }}
        >
          <Header
            selectedModel={selectedModel}
            isOpen={isOpen}
            isUserMenuOpen={isUserMenuOpen}
            fullname={fullname}
            handleToggle={handleToggle}
            handleModelChange={handleModelChange}
            handleFaqNavigation={handleFaqNavigation}
            handleOpenForm={handleOpenForm}
            setIsUserMenuOpen={setIsUserMenuOpen}
            dropdownRef={dropdownRef}
          />
          <div className="video-page">
            <button className="back-btn" onClick={handleBack}>
              <img src={arrowBack} alt="Back" className="icon-left" />
              Back
            </button>
            <div className="quick-reads">
              <span>Quick Reads</span>
              <div className="tags">
                <a href={userPDF} target="_blank" rel="noopener noreferrer">
                  UPL Genie User Guide
                  <img src={arrowIcon} alt="" className="tag-icon" />
                </a>

                <a href={faqPDF} target="_blank" rel="noopener noreferrer">
                  FAQs
                  <img src={arrowIcon} alt="" className="tag-icon" />
                </a>
              </div>
            </div>
            <div className="tutorial-videos">
               <span>Tutorial Videos</span>
            </div>
            <div className="video-grid three-columns">             
              {videos.map((video, index) => {
                return (
                  <div key={index} className="video-card-wrapper">
                    <div
                      className="video-card"
                      onClick={() => setPlayingIndex(index)}
                      style={{ cursor: "pointer" }}
                     
                    >
                      <a  
                      href={video.url}
                      target="_blank"
                      rel="noopener noreferrer">
                        <img
                          src={video.thumbnail}
                          alt={video.title}
                          className="video-thumbnail"
                        />
                        <span className="video-duration">{video.time}</span>
                      </a>
                    </div>
                    <p className="video-title-outside">{video.title}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
